import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../types/store';
import { getStudioParams, getPublishedTiers } from '../../selectors/studio';
import { Props } from './TierBreadcrumbs';

export type StateProps = Pick<Props, 'tiers' | 'tierId'>;
export type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = state => {
  return {
    tiers: getPublishedTiers(state),
    tierId: getStudioParams(state).tierId,
  };
};

export default connect(mapStateToProps);
